export default ($locationProvider, $urlRouterProvider) => {
    $locationProvider.html5Mode({
        enabled: false,
        requireBase: false
    });
    $urlRouterProvider.otherwise('/');

    // note we need to suppress eslint because rule func can only return modified path for some reason
    // eslint-disable-next-line consistent-return
    $urlRouterProvider.rule(($injector, $location) => {
        const path = $location.url();

        // remove slash if last character
        if (path[path.length - 1] === '/') {
            return path.substring(0, path.length - 1);
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/configs/routing/index.js